import React from 'react';

import {useTranslation} from "react-i18next";

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import LoadingButton from '@mui/lab/LoadingButton';

type AddNotesModalProps = {
    open: boolean
    handleClose: () => void
    title: string
    children: React.ReactNode
    handleAction: () => void
    type: "note" | "declined" | "query" | "accept"
    loading?: boolean;
    submittable?: boolean;
}

const ActionModal: React.FC<AddNotesModalProps> = (props) => {
    const {t} = useTranslation('common');

    const { type, open, handleClose, title, handleAction, loading = false, children, submittable = true } = props;

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                {children}
            </DialogContent>
            <DialogActions>
                <LoadingButton loading={loading} loadingIndicator={type === "note" ? `${t("save")}...` : `${t("send")}...`}
                               onClick={handleAction} autoFocus disabled={!submittable}>
                    {type === "note" ? t("save") : t("send")}
                </LoadingButton>
                <LoadingButton loading={loading}
                               onClick={handleClose}
                               color="inherit"
                               loadingIndicator={t("cancel")}
                               autoFocus>{t("cancel")}</LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default ActionModal;